import { Component, inject, OnDestroy, Signal } from '@angular/core';
import { stages } from '../../public-information-disclosure.routes';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { PublicInformationForm } from './forms/public-information.form';
import { updateApplication } from '../../../../../../store/actions/application.actions';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';

@Component({
  selector: 'app-public-information-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    CommonModule,
    ReactiveFormsModule,
    ValidationErrorsComponent
  ],
  providers: [PublicInformationForm],
  templateUrl: './public-information-section.component.html'
})
export class PublicInformationSectionComponent implements OnDestroy {

  public stages: string[] = stages;

  private router: Router = inject(Router);

  private route: ActivatedRoute = inject(ActivatedRoute);

  private store$: Store = inject(Store);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public form: PublicInformationForm = inject(PublicInformationForm);

  private fetchApplication: Subscription = toObservable(this.application).subscribe((app) => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  public onCancel(): void {
    this.router.navigate(['../dane-wniosku'], { relativeTo: this.route });
  }

  public submitAndGoNext(): void {
    if (this.form.valid) {
      this.store$.dispatch(updateApplication({
        id: this.application()?.uuid || '',
        application: this.form.value,
        successFnc: (applicationId: string) => {
          this.router.navigate(
            ['../zgody'],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }
}
